var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container content"},[(!_vm.showErrorMessage)?_c('h1',[_vm._v("Hold on tight...")]):_c('span',[_vm._v("Oida, her gikk noe galt. Klikk "),_c('a',{attrs:{"href":"/order"}},[_vm._v("her")]),_vm._v(" for å prøve igjen.")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-790f2aa3","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Complete.vue
// module id = null
// module chunks = 